// extracted by mini-css-extract-plugin
export var box = "_50-0";
export var check = "_50-1";
export var checkboxButton = "_50-6";
export var checkboxGroup = "_50-5";
export var disabled = "_50-7";
export var ghost = "_50-9";
export var input = "_50-2";
export var label = "_50-4";
export var normal = "_50-8";
export var uncheck = "_50-3";